import React, { useState, useEffect } from 'react';
import { FiRefreshCw, FiCalendar, FiZap, FiCheckCircle, FiAlertTriangle,FiEdit2 ,FiLayers, FiSettings } from 'react-icons/fi';
import { FaShopify } from 'react-icons/fa';


export default function AutomatedSEOScanning(){
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <FaShopify className="text-teal-500 text-3xl" />
            <span className="text-2xl font-bold bg-gradient-to-r from-blue-800 to-teal-500 bg-clip-text text-transparent">
              SEOAutoFix
            </span>
          </div>
          <nav className="hidden md:flex space-x-8">
            <a href="#" className="text-gray-600 hover:text-teal-500 transition">Dashboard</a>
            <a href="#" className="text-gray-600 hover:text-teal-500 transition">Reports</a>
            <a href="#" className="text-gray-600 hover:text-teal-500 transition">Settings</a>
          </nav>
          <button className="bg-gradient-to-r from-blue-800 to-teal-500 text-white px-4 py-2 rounded-md hover:opacity-90 transition shadow-md">
            Run New Scan
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-6 py-12">
        {/* Hero Section */}
        <section className="mb-16 text-center">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            <span className="bg-gradient-to-r from-blue-800 to-teal-500 bg-clip-text text-transparent">
              Automated SEO Scanning
            </span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Crawl your Shopify store to identify SEO issues and get actionable recommendations to boost your rankings.
          </p>
        </section>

        {/* Features Grid */}
        <section className="grid md:grid-cols-3 gap-8 mb-16">
          {/* Feature 1 */}
          <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition border border-gray-100">
            <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-4">
              <FiZap className="text-2xl text-blue-800" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">On-Demand Scans</h3>
            <p className="text-gray-600">
              Run instant SEO audits whenever you make changes to your store.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition border border-gray-100">
            <div className="w-14 h-14 rounded-full bg-teal-50 flex items-center justify-center mb-4">
              <FiRefreshCw className="text-2xl text-teal-500" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Scheduled Scans</h3>
            <p className="text-gray-600">
              Set weekly or monthly automated scans to monitor your SEO health.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition border border-gray-100">
            <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-4">
              <FiCheckCircle className="text-2xl text-blue-800" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Comprehensive Checks</h3>
            <p className="text-gray-600">
              Identifies 50+ SEO issues from meta tags to broken links.
            </p>
          </div>
        </section>

        {/* Scan Configuration */}
        <section className="bg-white rounded-xl shadow-sm p-8 mb-16 border border-gray-100">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Scan Configuration</h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Frequency Settings */}
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <FiCalendar className="text-teal-500 mr-2" />
                Scan Frequency
              </h3>
              <div className="space-y-3">
                <label className="flex items-center space-x-3">
                  <input type="radio" name="frequency" className="h-4 w-4 text-teal-500" defaultChecked />
                  <span className="text-gray-700">On-Demand Only</span>
                </label>
                <label className="flex items-center space-x-3">
                  <input type="radio" name="frequency" className="h-4 w-4 text-teal-500" />
                  <span className="text-gray-700">Weekly (Every Monday)</span>
                </label>
                <label className="flex items-center space-x-3">
                  <input type="radio" name="frequency" className="h-4 w-4 text-teal-500" />
                  <span className="text-gray-700">Monthly (1st of each month)</span>
                </label>
              </div>
            </div>

            {/* Scan Depth */}
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <FiAlertTriangle className="text-blue-800 mr-2" />
                Scan Depth
              </h3>
              <select className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition">
                <option>Standard (All products & pages)</option>
                <option>Deep Crawl (Including blog posts)</option>
                <option>Light (Only critical pages)</option>
              </select>
              <p className="text-sm text-gray-500 mt-2">
                Deeper scans take longer but provide more comprehensive results.
              </p>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 flex justify-end">
            <button className="bg-gradient-to-r from-blue-800 to-teal-500 text-white px-6 py-3 rounded-md hover:opacity-90 transition shadow-md">
              Save Settings
            </button>
          </div>
        </section>

        {/* Last Scan Results */}
        <section className="bg-white rounded-xl shadow-sm p-8 border border-gray-100">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">Last Scan Results</h2>
            <span className="text-sm text-gray-500">Completed: Today, 10:42 AM</span>
          </div>

          <div className="grid md:grid-cols-4 gap-6 mb-8">
            {/* Scan Summary Card */}
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
              <div className="text-blue-800 font-bold text-2xl mb-1">78</div>
              <div className="text-sm text-gray-600">SEO Score</div>
            </div>
            
            <div className="bg-red-50 p-4 rounded-lg border border-red-100">
              <div className="text-red-600 font-bold text-2xl mb-1">12</div>
              <div className="text-sm text-gray-600">Critical Issues</div>
            </div>
            
            <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-100">
              <div className="text-yellow-600 font-bold text-2xl mb-1">24</div>
              <div className="text-sm text-gray-600">Warnings</div>
            </div>
            
            <div className="bg-green-50 p-4 rounded-lg border border-green-100">
              <div className="text-green-600 font-bold text-2xl mb-1">142</div>
              <div className="text-sm text-gray-600">Optimized Items</div>
            </div>
          </div>

          <button className="w-full md:w-auto bg-gradient-to-r from-blue-800 to-teal-500 text-white px-6 py-3 rounded-md hover:opacity-90 transition shadow-md flex items-center justify-center space-x-2">
            <FiRefreshCw />
            <span>Run New Scan Now</span>
          </button>
        </section>
      </main>
    </div>
  );
};